import {createContext, useContext} from 'react';

export type NavigationContextType = {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
  /** Matches legacy journey `app--floating-sidebar` width animation. */
  widthTransition: boolean;
  setWidthTransition: (enabled: boolean) => void;
};

const noop = (_value: boolean) => undefined;

export const NavigationContext = createContext<NavigationContextType>({
  collapsed: false,
  setCollapsed: noop,
  widthTransition: false,
  setWidthTransition: noop,
});

export function useNavigationContext() {
  return useContext<NavigationContextType>(NavigationContext);
}
